// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ui-meet-3d-general-form .image-upload {\n  display: block;\n  margin-right: 10px;\n}\n.ui-meet-3d-general-form .image-upload label {\n  display: block;\n}\n.ui-meet-3d-general-form .image-upload .checkbox {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.ui-meet-3d-general-form .image-upload .ui.image {\n  margin-left: auto;\n  margin-right: auto;\n}\n.ui-meet-3d-general-form .image-upload p {\n  margin-top: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
